export enum BroadcastUserTypeEnum {
    None = 0,
    Drivers = 1,
    Customers = 2
}
